<script lang="ts" setup>
import { useAuth0 } from '@auth0/auth0-vue';
import { ref } from 'vue';

const auth0 = useAuth0();
const isLoading = ref(auth0.isLoading);
const isAuthenticated = ref(auth0.isAuthenticated);

if (isLoading.value || isAuthenticated.value) {
  window.location.href = 'https://spectee.co.jp/';
} else if (window.location.search.includes('invitation=')) {
  const urlSearchParams = new URLSearchParams(window.location.search);

  localStorage.setItem(
    'organization',
    urlSearchParams.get('organization') || ''
  );
  localStorage.setItem(
    'organization_name',
    urlSearchParams.get('organization_name') || ''
  );

  const invitation = urlSearchParams.get('invitation') ?? undefined;
  const id = urlSearchParams.get('organization_name') ?? undefined;
  const redirect = import.meta.env.VITE_APP_REDIRECT_URI;

  auth0.loginWithRedirect({
    authorizationParams: {
      invitation,
      redirect_uri: redirect.replace('*', id),
    },
  });
} else {
  // invitationが無い場合は通常のログイン処理
  auth0.loginWithRedirect();
}
</script>
